module.exports = __webpack_public_path__ + "img/vertical_3_4_9016.cb17e285.png";